import React, { useMemo } from "react";
import { MachineCenterTrafficLightsIcons } from "./MachineCenterTrafficLightsIcons.view";
import { useStyles } from "./MachineCenterTrafficLights.styles";
import { IMachineCenterTrafficLightsProps } from "./MachineCenterTrafficLightsInterfaces";
import { IconsTrafficLightStatusCodes } from "constants/constants";

export const MachineCenterTrafficLights = ({
    status,
    isBottleneck,
    noPercentageData,
    bigSize,
    styleCluster,
}: IMachineCenterTrafficLightsProps) => {
    const classes = useStyles();

    const statusStyles = useMemo(() => {
        if (status === IconsTrafficLightStatusCodes.OFFLINE) {
            return classes.offline;
        }
        if (status === IconsTrafficLightStatusCodes.UP) {
            return classes.up;
        }
        if (status === IconsTrafficLightStatusCodes.DOWN) {
            return classes.down;
        }
        if (status === IconsTrafficLightStatusCodes.END_OF_SHIFT) {
            if (noPercentageData) {
                return classes.noData;
            }
            return classes.endOfShift;
        }
        if (status === IconsTrafficLightStatusCodes.BELOW_TRIGGER) {
            return classes.belowTrigger;
        }
        return classes.up;
    }, [
        classes.down,
        classes.offline,
        classes.up,
        status,
        classes.endOfShift,
        noPercentageData,
        classes.noData,
        classes.belowTrigger,
    ]);

    return (
        <div style={styleCluster} className={`${bigSize ? classes.bigCircle : classes.circle} ${statusStyles}`}>
            {
                <MachineCenterTrafficLightsIcons
                    status={status}
                    isBottleneck={isBottleneck}
                    noPercentageData={noPercentageData}
                    bigSize={bigSize}
                />
            }
        </div>
    );
};
